export default __webpack_public_path__ + "static/logo-text-e766ee93cebc5d1e8075e796191012f0.svg";